import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// Initialise Sentry in its own module so it can be imported *before* the App
// module graph in index.tsx. ES module imports are evaluated in source order,
// so importing this first guarantees Sentry is initialised before any of App's
// modules evaluate — otherwise an import-time error (e.g. an unsupported JS
// built-in on older iOS WebKit) throws before init and is never captured,
// surfacing only as a blank/grey screen with nothing in Sentry. See BLUM-6399.
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://7051f09cfdfc4ab48eb44a20839ad602@o4504439871766528.ingest.sentry.io/4504548591992832',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT,
    // Env-driven so the release matches the deployed build and source maps resolve.
    // Falls back to the previous hardcoded value when the env var is unset.
    release: process.env.REACT_APP_SENTRY_RELEASE || 'apos-hub@1.0.0',
  });
}
